export default __webpack_public_path__ + "static/media/e_testing.467c9f4b.png";